import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'redux-form';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import { USER_WAIVER_EXPIRATION_DAYS } from 'ab-common/constants/value';

import DateInput from 'af-fields/DateInput';

import Checkbox from 'af-components/Controls/Checkbox';

interface OwnProps {
	/** MM-DD-YYYY */
	waiverStatusValidFrom: Nullable<string>;
	/** YYYY-MM-DD */
	timeRoundingPolicyFrom: string;
	change: (field: string, value: string | null) => void;
}

type Props = OwnProps;

const UserWaiverStatus: React.FC<Props> = (props) => {
	const { waiverStatusValidFrom, timeRoundingPolicyFrom, change } = props;

	const [waiverCheckbox, setWaiverCheckbox] = React.useState<boolean>(!!waiverStatusValidFrom);
	/** MM-DD-YYYY */
	const [waiverValidFrom, setWaiverValidFrom] = React.useState<Nullable<string>>(null);

	React.useEffect(() => {
		setWaiverCheckbox(!!waiverStatusValidFrom);
		if (waiverStatusValidFrom) {
			setWaiverValidFrom(waiverStatusValidFrom);
		}
	}, [waiverStatusValidFrom]);

	const calendarAvailableDates = React.useMemo(() => {
		return {
			minDate: TimeUtils.parseDate(timeRoundingPolicyFrom, TimeFormat.DB_DATE_ONLY),
			maxDate: new Date(),
		};
	}, [timeRoundingPolicyFrom]);

	const handleChange = React.useCallback(() => {
		setWaiverCheckbox(!waiverCheckbox);
		if (waiverCheckbox) {
			setWaiverValidFrom(null);
			change('waiverStatusValidFrom', null);
		} else {
			waiverValidFrom && setWaiverValidFrom(waiverValidFrom);
		}
	}, [change, waiverCheckbox, waiverValidFrom]);

	const handleDateSignedChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		setWaiverValidFrom(e.target.value);
	}, []);

	const expirationDate = React.useMemo(() => {
		const selectedDate = waiverValidFrom;

		if (!selectedDate) {
			return null;
		}
		return TimeUtils.formatDate(
			TimeUtils.addDays(selectedDate, USER_WAIVER_EXPIRATION_DAYS, TimeFormat.DATE_ONLY),
			TimeFormat.DATE_ONLY
		);
	}, [waiverValidFrom]);

	return (
		<div className="user-upsert__invite">
			<Row className="p-l-0">
				<Col className="p-l-0" sm={12}>
					<Checkbox
						handleChange={handleChange}
						inline={true}
						isChecked={!!waiverCheckbox}
						isDisabled={false}
						label="Signed - VOLUNTARY SECOND MEAL PERIOD WAIVER AGREEMENT"
						tooltipMessage="Once saved, the waiver is applied to all affected time sheets. Job payroll report will be changed, even in the past!"
					/>
				</Col>
			</Row>
			<Row className="p-l-0 p-t-m">
				{(waiverCheckbox) &&
					<Col className="p-l-0 p-r-m" sm={12}>
						<Field
							calendarSettings={calendarAvailableDates}
							component={DateInput}
							dateFormat={TimeFormat.DATE_ONLY}
							disabled={false}
							id="dateSigned"
							isRequired={false}
							label="Date signed"
							name="waiverStatusValidFrom"
							onChange={handleDateSignedChange}
							originalDateFormat={TimeFormat.DATE_ONLY}
							placeholderText={TimeFormat.DATE_ONLY}
							required={false}
						/>
					</Col>
				}
				{(!!waiverValidFrom) &&
					<Col className="p-l-0 p-r-m" sm={12}>
						<div>
							<span>Waiver Expiration Date</span>
							<div className="p-t-s">
								<strong>
									{expirationDate}
								</strong>
							</div>
						</div>
					</Col>
				}
			</Row>
		</div>
	);
};

export default React.memo(UserWaiverStatus);
